// extracted by mini-css-extract-plugin
export default {"container":"CGUModal_container__UlDbI","actions":"CGUModal_actions__mCmbj","checkbox":"CGUModal_checkbox__3bEt0","acceptBtn":"CGUModal_acceptBtn__HB710"};